document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('shipForm');
    const btn = document.getElementById('btn');
    const msg = document.getElementById('msg');

    if (!form) return;

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        // UI Reset
        btn.disabled = true;
        btn.innerText = "Processing Shipment...";
        msg.style.display = "none";
        msg.style.background = "transparent";

        const payload = {
            name: document.getElementById('name').value,
            phone: document.getElementById('phone').value,
            address: document.getElementById('addr').value,
            suburb: document.getElementById('suburb').value,
            city: document.getElementById('city').value,
            pcode: document.getElementById('pcode').value
        };

        try {
            // Updated with your live Render URL
            const response = await fetch('https://bobgo-backend.onrender.com/ship', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            // Check if the response is valid JSON
            const contentType = response.headers.get("content-type");
            if (!contentType || !contentType.includes("application/json")) {
                throw new Error("Server sent back HTML instead of Data. Check Render Logs.");
            }

            const result = await response.json();

            if (response.ok) {
                // SUCCESS
                msg.innerHTML = `
                    <strong>Waybill Generated!</strong><br>
                    Sent to: bohang.mohale@ofyt.co.za<br>
                    <a href="${result.waybill}" target="_blank" class="download-link">Download PDF Waybill</a>
                `;
                msg.style.display = "block";
                msg.style.background = "#e6fffa";
                msg.style.color = "#234e52";
                msg.style.border = "1px solid #b2f5ea";
                form.reset();
            } else {
                // SERVER RETURNED ERROR (e.g. 400 or 500)
                throw new Error(result.error || "Shipment failed. Please check address.");
            }
        } catch (err) {
            // NETWORK OR PARSING ERROR
            msg.innerText = "Error: " + err.message;
            msg.style.display = "block";
            msg.style.background = "#fff5f5";
            msg.style.color = "#c53030";
            msg.style.border = "1px solid #feb2b2";
        } finally {
            btn.disabled = false;
            btn.innerText = "GENERATE WAYBILL";
        }
    });
});